<div class="topline">
  <h2>CLOs</h2>
  <button mat-raised-button color="primary" (click)="addRebate()">Add CLO</button>
</div>

<div class="filters">
  <mat-form-field appearance="outline" class="search">
    <mat-label>Search</mat-label>
    <input matInput [(ngModel)]="searchValue" (ngModelChange)="queueFilter($event)">
  </mat-form-field>
</div>

<div class="scroll-container" (scroll)="onScroll($event)">
  <table mat-table [dataSource]="items" class="table">
    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef>Title</th>
      <td mat-cell *matCellDef="let rebate">{{rebate.title}}</td>
    </ng-container>

    <ng-container matColumnDef="transactionRegExp">
      <th mat-header-cell *matHeaderCellDef>Match Expression</th>
      <td mat-cell *matCellDef="let rebate">{{rebate.transactionRegExp}}</td>
    </ng-container>

    <ng-container matColumnDef="redeemDetails">
      <th mat-header-cell *matHeaderCellDef>Redeem Details</th>
      <td mat-cell *matCellDef="let rebate">{{rebate.redeemDetails}}</td>
    </ng-container>

    <ng-container matColumnDef="schedule">
      <th mat-header-cell *matHeaderCellDef>Schedule</th>
      <td mat-cell *matCellDef="let rebate">{{rebate.schedule}}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['title','transactionRegExp','redeemDetails','schedule']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['title','transactionRegExp','redeemDetails','schedule']" (click)="editRebate(row)"></tr>
  </table>

  @if (loading) {
    <div class="loading">Loading...</div>
  }
  @if (!loading && items.length === 0) {
    <div class="empty">There are no bank account CLO rebates to show.</div>
  }
</div>
